import { Directive } from '@angular/core';

@Directive({
  selector: '[coreUiAttachmentCardAction]',
  standalone: false,
})
export class CoreUIAttachmentCardActionDirective {}
